// Media URL helpers - normalize direct MP4, YouTube, Google Drive, Vimeo URLs into playable embeds.

const YT_HOSTS = new Set(["www.youtube.com", "youtube.com", "youtu.be", "m.youtube.com"]);
const DRIVE_HOSTS = new Set(["drive.google.com"]);
const VIMEO_HOSTS = new Set(["vimeo.com", "www.vimeo.com", "player.vimeo.com"]);

export function detectMedia(url) {
    if (!url) return { type: "none", src: "" };
    url = url.trim();
    if (!url) return { type: "none", src: "" };
    const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(url) ? url : `https://${url}`;
    let u;
    try { u = new URL(withProtocol); } catch { return { type: "direct", src: url }; }
    const host = u.hostname.toLowerCase();

    if (YT_HOSTS.has(host)) {
        let id = "";
        if (host === "youtu.be") {
            id = u.pathname.replace(/^\//, "").replace(/\/$/, "");
        } else if (u.pathname === "/watch") {
            id = u.searchParams.get("v") || "";
        } else if (u.pathname.startsWith("/embed/")) {
            id = u.pathname.split("/embed/")[1] || "";
        } else if (u.pathname.startsWith("/shorts/")) {
            id = u.pathname.split("/shorts/")[1] || "";
        } else if (u.pathname.startsWith("/live/")) {
            id = u.pathname.split("/live/")[1] || "";
        }
        if (id) return { type: "youtube", src: `https://www.youtube.com/embed/${id}?rel=0` };
    }
    if (DRIVE_HOSTS.has(host)) {
        // /file/d/<ID>/view or ?id=<ID>
        const m = u.pathname.match(/\/file\/d\/([^/]+)/);
        const id = m ? m[1] : (u.searchParams.get("id") || "");
        if (id) return { type: "drive", src: `https://drive.google.com/file/d/${id}/preview` };
    }
    if (VIMEO_HOSTS.has(host)) {
        // vimeo.com/<id>, vimeo.com/<id>/<hash> (unlisted), vimeo.com/channels/x/<id>,
        // vimeo.com/groups/x/videos/<id>, or already player.vimeo.com/video/<id>?h=<hash>
        const parts = u.pathname.split("/").filter(Boolean);
        const idIdx = parts.findIndex((p) => /^\d+$/.test(p));
        const id = idIdx >= 0 ? parts[idIdx] : "";
        const hash = u.searchParams.get("h") || parts[idIdx + 1] || "";
        if (id) {
            const embed = new URL(`https://player.vimeo.com/video/${id}`);
            if (hash) embed.searchParams.set("h", hash);
            return { type: "vimeo", src: embed.href };
        }
    }
    return { type: "direct", src: u.href };
}
